import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const CsdMlDlWorkshopSept2025 = () => {
    const workshopImages = [
        "workshop1.jpg",
        "workshop2.jpg",
        "workshop3.jpg",
        "workshop4.jpg",
        "workshop5.jpg",
        "workshop6.jpg",
    ];
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>CSD Workshop: Unlocking the Power of Machine Learning & Deep Learning</h2>
                                    <div className='py-2'>
                                        <p>
                                            The Department of Computer Science & Engineering (Data Science) at Sridevi Women’s Engineering College successfully organized a 3-day hands-on workshop on “Unlocking the Power of Machine Learning and Deep Learning” on the 23rd, 24th, and 25th of September 2025. The sessions were led by distinguished speakers Mr. U. Nageswar Rao, Founder & Director of Nextera Unitech, and Mr. R. Akhil, Data Scientist at Nextera Unitech. The workshop provided students with practical exposure and valuable insights into the applications of ML and DL, enhancing their skills for future technological innovations.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/CSD-Department-Workshop-Sept-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/CSD-Department-Workshop-Sept-2025/${img}`}
                                                            alt={`Workshop Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default CsdMlDlWorkshopSept2025;
